import styled from "styled-components";

export const Styles = styled.div`
  margin-bottom: 3rem;
  width: 100%;
  h4 {
    margin-bottom: 15px;
  }
  table {
    table-layout: fixed;
    border-spacing: 0;
    border: 1px solid #e9e9e9;
    &.react-table-submitted,
    &.react-table-historical {
      td,
      th {
        &:last-child,
        &:first-child {
          width: 2%;
        }
      }
    }
    &.react-table-initiated {
      td,
      th {
        &:first-child {
          width: 2%;
        }
      }
    }

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    thead {
      background-color: #f7f7f7;
    }
    tbody {
      position: relative;
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid #e9e9e9;
      border-right: 1px solid #e9e9e9;
    }
  }
`;

export const TH = styled.th`
  padding: 0 !important;
  width: 16%;
`;

export const TD = styled.td`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  /* max-width: 100px; */

  /* width: 16%; */

  ${(props) =>
    props.loader &&
    `
    background-color: #f7f7f7;
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid #e9e9e9;
  `}
`;

export const TDIcon = styled.div`
  color: red;
  cursor: pointer;
  transition: all 0.25s;
  &:hover {
    opacity: 0.75;
  }
  svg {
    float: left;
    width: 38px;
  }
`;

export const TH_Container = styled.div`
  padding: 0.5rem;
  display: flex;
  justify-content: space-between;
  ${(props) => props.isSorted && `background-color: #efefef`}
`;

export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  ${(props) =>
    props.paginationDisable &&
    `
  display: none;
  `};

  ${(props) =>
    props.isExpandedRow
      ? `
      padding-bottom: 20px;
  `
      : `
      padding-top: 20px;
  `}
  .input-page {
    margin: 0 2rem;
  }

  select {
    margin-left: 1rem;
  }
`;

export const PageNavButton = styled.button`
  background-color: #f7fafd;
  border: 1px solid white;
  border-radius: 5px;
  color: #7fa1c8;
  height: 34px;
  width: 34px;
  padding: 0;

  &:hover:enabled {
    color: #7fa1c8;
    background-color: #e4f0fb;
  }

  &:disabled {
    background-color: #f7f7f7;
    cursor: not-allowed;
    color: lightgray;
  }

  ${(props) =>
    props.isExpandedRow &&
    `
    padding: 4px;
    color: #0071BC;
    background-color: transparent;
    border: none;
    &:hover:enabled {
      background-color: rgba(0, 113, 189, 0.1);
    }
    &:disabled {
      color: #a0b2bd;
      background-color: transparent;
    }
    border-radius: 100px;
  `};
`;

export const PageInput = styled.input`
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: #fff;
  padding: 5px 7px;
  font-size: inherit;
  border-radius: 3px;
  font-weight: normal;
  outline: none;
  width: 60px;
  text-align: center;
  ${(props) =>
    props.isExpandedRow &&
    `
    border-radius: 8px;
  `};
`;

export const CaseCounter = styled.div`
  height: 40px;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 0.8rem;
  font-weight: bold;
  color: #5b616b;
  text-transform: uppercase;
  display: flex;
  align-items: flex-end;
  width: 100%;
`;

export const RefineSearch = styled.div`
  /* margin-left: auto; */
`;

export const CaseTableActions = styled.div`
  display: flex;
  flex-basis: auto;
  padding: 0 10px 0 10px;
  /* height: 57px; */
  /* margin: 0 30px 0 30px; */
  background: #f7f7f7;
  border-radius: 3px;
  border: 1px solid #e9e9e9;
  text-transform: capitalize;
  .badge {
    color: white;
    width: 35px;
    height: 23px;
    margin-left: 4px;
    border-radius: 20px;
    margin-bottom: 4px;
    font-size: 1em;
    background-color: rgba(0, 0, 0, 0.5);
    border: 0px;
  }
  .top {
    font-size: 120%;
  }
  .bottom {
    color: #005ea2;
    float: right;
    font-size: 80%;
  }
  .clearCasesBtn,
  .reassign,
  .delete {
    float: left;
    padding: 5px 0px 5px 8px;
  }
  .reassignButton,
  .deleteButton {
    transition: all 0.25s;
    &:hover {
      color: white !important;
      outline: none;
    }
  }
  .reassignButton:hover {
    background-color: #2d71bc;
  }
  .deleteButton:hover {
    background-color: red;
  }
`;

export const CaseTableActionsDivider = styled.div`
  width: 2px;
  height: 40px;
  margin-left: 15px;
  margin-right: 0px;
  border: 1px solid #e9e9e9;
`;

export const CaseActionButton1 = styled.div`
  border: 1.5px solid #2d71bc;
  border-radius: 30px;
  padding: 0 7px;
  color: #2d71bc;
  border-bottom: 1.5px solid #2d71bc;
  transition: all 0.25s;
  font-size: 16px;
  font-weight: 500;
  line-height: 26px;
  display: inline-block;
  position: relative;
  top: 5px;
  right: -10px;
`;

export const StyledAccordion = styled.div`
  background: #ededed;
  padding: 12px 30px 24px 30px;
  width: 100%;
  h4 {
    color: #215593;
    font-size: 24px;
  }
`;

export const StyledAccordionResults = styled.div`
  table {
    border: none;
    /* thead {
      background-color: transparent;
    }
    thead tr {
      padding: 12px 0;
    } */

    /* tbody tr {
      padding: 16px 24px;
    } */
    /* tbody {
      display: grid;
      grid-row-gap: 24px;
    } */
    tr {
      /* overflow: hidden;
      display: grid;
      grid-column-gap: 10px; */
      border: none;
      background-color: #ededed;
      grid-template-columns: ${(props) =>
        props.type === "notes"
          ? `
            170px 150px 1fr;
          `
          : `
           200px 1fr;
      `};
    }
    td {
      white-space: normal;
      width: auto;
    }
    th {
      white-space: nowrap;
      cursor: pointer;
    }
    th,
    td {
      border: none;
    }
  }
`;

export const SubComponent = styled.div`
  border-top: 1px solid #e9e9e9;
  border-left: 5px solid #e9e9e9;
  background: #f7f7f7;
  padding: 0 0 1rem 2.5rem;
  button {
    svg {
      position: relative;
      font-size: 0.8rem;
    }
  }

  .column-align {
    margin: 20px 0;
  }
  .left-align {
    text-align: left;
    margin-right: 10px;
    p {
      margin: 5px 0;
    }
    .expand-edit-btn {
      margin-top: 10px;
    }
  }
  .right-align {
    text-align: right;
    p {
      font-weight: 700;
      margin: 5px 0;
      margin-right: 10px;
    }
  }
`;

export const StatusPill = styled.div`
  text-transform: uppercase;
  border-radius: 2px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-overflow: ellipsis;
  overflow: hidden;

  // default
  background: #f1f1f1;
  font-weight: bold;
  font-size: 0.8rem;
  text-align: center;
  color: #000;
  border: 1px solid #aeb0b5;

  ${(props) =>
    (props.status === "in-process" || props.status === "pending-processing") &&
    `
  background:  #e1f3f8;
  border: 1px solid  #03bfe7;
  `}

  ${(props) =>
    (props.status === "initiated" || props.status === "active") &&
    `
  background: #fff1d2;
  border: 1px solid #fdb81e;
  `}

span {
    padding: 4px;
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;
